export {
  Title,
  Tip,
  shallowIntl,
  createIntl,
  intl,
  createSetterContent,
  obx,
  observable,
  makeObservable,
  untracked,
  computed,
  observer,
  globalLocale,
} from '@alilc/lowcode-editor-core';